"use client";

import { useRef, useEffect } from "react";
import styles from "../../styles/AboutUs.module.css";

const TimelineSection = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add(styles.visible);
          } else {
            entry.target.classList.remove(styles.visible);
          }
        });
      },
      {
        threshold: 0.3,
        rootMargin: "0px 0px -50px 0px",
      }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
    };
  }, []);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        position: "relative",
        overflow: "hidden",
        width: "100%", // Add this
      }}
    >
      {/* CSS Animations */}
      <style jsx>{`
        /* Fix: Prevent overflow during animation */
        .${styles.slidContainer} {
          overflow: hidden !important;
          width: 100%;
          contain: content; /* This helps prevent layout shifts */
        }
        
        .${styles.sliderWrapper} {
          position: relative;
          width: 100%;
        }

        .${styles.slideBox} {
          opacity: 0;
          transform: translateX(100px);
          transition: opacity 0.8s ease-out, transform 0.8s ease-out;
          will-change: transform, opacity; /* Optimize animations */
        }

        /* First two from right */
        .${styles.sliderWrapper}:nth-child(1) .${styles.slideBox}:nth-child(-n + 2),
        .${styles.sliderWrapper}:nth-child(2) .${styles.slideBox}:nth-child(-n + 2) {
          transform: translateX(100px);
        }

        /* Last two from left */
        .${styles.slideBox}:nth-child(3),
        .${styles.slideBox}:nth-child(4) {
          transform: translateX(-100px);
        }

        /* When visible class is added */
        .${styles.visible} .${styles.slideBox} {
          opacity: 1 !important;
          transform: translateX(0) !important;
        }

        /* Staggered delays */
        .${styles.visible} .${styles.slideBox}:nth-child(1) { transition-delay: 0s; }
        .${styles.visible} .${styles.slideBox}:nth-child(2) { transition-delay: 0.2s; }
        .${styles.visible} .${styles.slideBox}:nth-child(3) { transition-delay: 0.4s; }
        .${styles.visible} .${styles.slideBox}:nth-child(4) { transition-delay: 0.6s; }
      `}</style>

      {/* Timeline Header */}
      <div className={styles.timelineSection}>
        <p style={{ fontSize: "30px", color: "green", marginBottom: "0" }}>
          TIMELINE
        </p>
        <h3 style={{ fontSize: "1.5em", marginTop: "5px" }}>
          Over 4 years of experience{" "}
          <span className={styles.mobileBreak}>
            <br />
          </span>{" "}
          in the industry
        </h3>
      </div>

      {/* Animated Slider */}
      <div
        className={styles.slidContainer}
        ref={containerRef}
        style={{ 
          overflow: "hidden",
          width: "100%",
          position: "relative" // Add this
        }}
      >
        <div className={styles.sliderWrapper}>
          <div className={styles.slideBox}>
            <h4 style={{ color: "var(--primary-green)", paddingRight: "25px", margin: "0", fontSize: "1.2em" }}>
              2021
            </h4>
            <h4 style={{ fontSize: "1.3em", color: "black", margin: "0 0 8px 0" }}>
              Our Establishment: A Bold Beginning
            </h4>
            <p className={styles.paragraph} style={{ color: "black", paddingBottom: "53px" }}>
              Arifpay was established in 2021 with 140 million Birr in seed funding, led by its founders to build a new standard for digital payments in Ethiopia.
            </p>
          </div>

          <div className={styles.slideBox}>
            <h4 style={{ color: "var(--primary-green)", paddingRight: "25px", margin: "0", fontSize: "1.2em" }}>
              2022
            </h4>
            <h4 style={{ fontSize: "1.3em", color: "black", marginBottom: "8px" }}>
              Regulatory Milestone
            </h4>
            <p className={styles.paragraph} style={{ color: "black" }}>
              Arifpay received its commercialization letter from the National Bank of Ethiopia, officially authorizing it to begin operations.
            </p>
          </div>

          <div className={styles.slideBox}>
            <h4 style={{ color: "var(--primary-green)", paddingRight: "25px", margin: "0", fontSize: "1.2em" }}>
              2023
            </h4>
            <h4 style={{ fontSize: "1.3em", color: "black", marginBottom: "8px" }}>
              Launch of Operations
            </h4>
            <p className={styles.paragraph} style={{ color: "black", paddingBottom: "53px" }}>
              Arifpay officially commenced its digital payment operations, bringing its services to market across Ethiopia operations.
            </p>
          </div>

          <div className={styles.slideBox} style={{ paddingBottom: "20px", paddingRight: "70px" }}>
            <h4 style={{ color: "var(--primary-green)", margin: "0", fontSize: "1.2em" }}>
              2024
            </h4>
            <h4 style={{ fontSize: "1.3em", color: "black", marginBottom: "8px" }}>
              Accelerated Growth
            </h4>
            <p className={styles.paragraph} style={{ color: "black" }}>
              Arifpay expanded its services and product offerings and product offerings, achieving a 110% increase in revenue by the end of the year.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TimelineSection;